export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref4630.7039abbf.jpg";